export default {
  setLeads (state, payload) {
    state.leads = payload
  },

  setDesempenho (state, payload) {
    state.desempenho = payload
  },

  setRankNovos (state, payload) {
    state.rankNovos = payload
  },

  setRankLeads (state, payload) {
    state.rankLeads = payload
  },

  setRankUsados (state, payload) {
    state.rankUsados = payload
  },

  setRankConsorcio (state, payload) {
    state.rankConsorcio = payload
  },

  setHistoricoRank (state, payload) {
    state.historicoRank = payload
  },

  setEmpresas (state, payload) {
    state.empresas = payload
  }
}
